// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__2_QWt","centered":"Text_centered__2vTF4","blue":"Text_blue__189TP","bold":"Text_bold__2u43d"};